import axios from '@/utils/http';

export default (id, action) => {
  return axios
    .post(`/multisig_orders/${id}/${action}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
